import { Multiselect } from 'multiselect-react-dropdown'
import { useState, useEffect } from 'react'

export default function MultiSelectOption({ values, label, name, handler, required }) {
  const [state, setState] = useState()
  const _onSelect = (selectedList, selectedItem) => handler(selectedList)
  const _onRemove = (selectedList, selectedItem) => { console.log(selectedList) }
  useEffect(() => {
    setState(values)
  }, [values])

  return (
    <div className='form-group'>
      <label className='text-uppercase'>
        {label} {required && <strong className="text-danger">*</strong>}
      </label>
      <Multiselect options={state} onSelect={_onSelect} onRemove={_onRemove} displayValue="name" />
    </div>
  )
}
